import { createFileRoute } from '@tanstack/react-router';
import { ClientsPage } from '../clients-page';
import { ClientsCard } from '../firm/clients-card';
import { FeatureGate } from '../firm/feature-gate';
import { TableSearch } from '../table-search';

export const Route = createFileRoute('/clients/')({
  // The table keeps its view in the address.
  validateSearch: TableSearch,
  component: Clients,
});

/** Prospects, intakes and clients of the firm in one list (ADR-037), with CHECK-POINT. */
function Clients() {
  return (
    <ClientsPage>
      <FeatureGate feature="check-point">
        <ClientsCard />
      </FeatureGate>
    </ClientsPage>
  );
}
